/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptions, FxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptionsFromJSONTyped, FxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptionsToJSON, } from './FxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptions';
export function FxIdApplicationPublicDataBuilderPlatformDataOptionsWebFromJSON(json) {
    return FxIdApplicationPublicDataBuilderPlatformDataOptionsWebFromJSONTyped(json, false);
}
export function FxIdApplicationPublicDataBuilderPlatformDataOptionsWebFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptions(json)) {
        return FxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptionsFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdApplicationPublicDataBuilderPlatformDataOptionsWebToJSON(json) {
    return FxIdApplicationPublicDataBuilderPlatformDataOptionsWebToJSONTyped(json, false);
}
export function FxIdApplicationPublicDataBuilderPlatformDataOptionsWebToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptions(value)) {
        return FxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptionsToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdApplicationPublicDataBuilderPlatformDataOptionsWeb.js.map